<template>
  <router-link
    v-if="item.to"
    class="left-nav-item"
    :to="item.to"
    :class="{ active: routeMatches, advanced: item.advanced }"
    :data-test="dataTest"
    :data-test-nav="`mobile-nav-left-${item.advanced ? 'advanced' : 'not-advanced'}`"
    @mouseover="focus"
    @mouseleave="blur"
    @click="$emit('close')"
  >
    <font-awesome-icon :icon="icon?.icon" class="tw-mr-4 tw-w-4" />
    <div class="nav-text">
      {{ item.name }}
      <Pill v-if="item.admin" class="ms-1" content="Admin" variant="highlight" />
    </div>
  </router-link>
  <div
    v-else
    class="left-nav-item"
    @click="executeAction(item.action)"
    :class="{ active: routeMatches, advanced: item.advanced }"
    :data-test="dataTest"
    @mouseover="focus"
    @mouseleave="blur"
  >
    <font-awesome-icon :icon="icon?.icon" class="tw-mr-4 tw-w-4" />
    <div class="nav-text">
      {{ item.name }}
      <Pill v-if="item.admin" class="ms-1" content="Admin" variant="highlight" />
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import Pill from "@/components/display/Pill";
import router from "@/router";

export default {
  name: "NavTopMobileItem",
  components: {
    Pill,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ["close"],
  setup(props, { emit }) {
    const active = ref(false);

    const blur = () => (active.value = false);

    const dataTest = computed(
      () => `mobile-nav-left-${props.item.name.toLowerCase().replace(/(,|_| |;)/g, "-")}`
    );

    const executeAction = (action) => {
      action();
      emit("close");
    };

    const focus = () => (active.value = true);

    const icon = computed(() =>
      routeMatches.value || active.value
        ? props.item?.icon?.hover || props.item?.icon?.default
        : props.item?.icon?.default
    );

    const routeMatches = computed(() => {
      const route = router?.currentRoute?.value;
      const matchedRoutes = [...route.matched];
      const match = matchedRoutes.reverse().find((route) => props.item.routeName === route?.name);
      return !!match;
    });

    return {
      blur,
      dataTest,
      executeAction,
      focus,
      icon,
      routeMatches,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
$nav-item-height-mobile: 45px;

.left-nav-item {
  font-size: 0.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: $nav-item-height-mobile;
  cursor: pointer;
  padding-left: $nav-padding-side;
  scroll-snap-align: end;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  .nav-icon {
    margin-right: 1rem;
  }

  @-webkit-keyframes fadeInAppear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeInAppear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  &.advanced {
    -webkit-animation-name: fadeInAppear;
    animation-name: fadeInAppear;
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    opacity: 0;
  }
}
</style>
